var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrint = function SvgPrint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 12H26.5V6.875C26.5 6.3125 26.25 5.8125 25.875 5.4375L21.0625 0.625C20.6875 0.25 20.1875 0 19.625 0H8.375C7.3125 0 6.5 0.9375 6.5 2V12H5.5C2.6875 12 0.5 14.25 0.5 17V23C0.5 23.5625 0.9375 24 1.5 24H6.5V31C6.5 31.5625 6.9375 32 7.5 32H25.5C26 32 26.5 31.5625 26.5 31V24H31.5C32 24 32.5 23.5625 32.5 23V17C32.5 14.25 30.25 12 27.5 12ZM20.5 2.875L23.625 6H20.5V2.875ZM8.5 2H18.5V6C18.5 7.125 19.375 8 20.5 8H24.5V12H8.5V2ZM24.5 30H8.5V24H24.5V30ZM30.5 22H2.5V17C2.5 15.375 3.8125 14 5.5 14H27.5C29.125 14 30.5 15.375 30.5 17V22ZM25.5 16.5C24.625 16.5 24 17.1875 24 18C24 18.875 24.625 19.5 25.5 19.5C26.3125 19.5 27 18.875 27 18C27 17.1875 26.3125 16.5 25.5 16.5Z",
    fill: "#605FF3"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/print.4e9efaa6.svg";
export { ForwardRef as ReactComponent };